// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"318":"praxis","353":"contact","774":"imprint","957":"privacy"}[chunkId] + "." + {"318":"712f8920","353":"d7ae3348","774":"fa82b793","957":"7a016bfb"}[chunkId] + ".css";
};